/* ==========================================================================
   Orbly V2 — Dark / Light Mode Toggle
   FOLT-safe: data-theme and metadata are initialized inline in <head>.
   Runtime owns toggle clicks, system changes and defensive metadata cleanup.
   ========================================================================== */
(function(){
  'use strict';

  try{localStorage.removeItem('orbly-theme')}catch(e){}
  var KEY='orbly-theme-v2';
  var COLORS={light:'#f8f8f8',dark:'#0E0B08'};

  function sys(){
    var mq=window.matchMedia&&window.matchMedia('(prefers-color-scheme:dark)');
    return (mq&&mq.matches)?'dark':'light';
  }

  function stored(){
    try{return localStorage.getItem(KEY)}catch(e){return null}
  }

  function cur(){
    return document.documentElement.getAttribute('data-theme')||sys();
  }

  function activeBg(mode){
    var css=getComputedStyle(document.documentElement).getPropertyValue('--color-bg').trim();
    return css||COLORS[mode]||COLORS.light;
  }

  function syncThemeMetadata(mode){
    var meta=document.getElementById('orbly-theme-color');
    if(!meta){
      meta=document.createElement('meta');
      meta.id='orbly-theme-color';
      meta.name='theme-color';
      document.head.appendChild(meta);
    }

    document.querySelectorAll('meta[name="theme-color"]').forEach(function(item){
      if(item!==meta)item.remove();
    });

    var color=activeBg(mode);
    meta.setAttribute('content',color);

    var scheme=document.getElementById('orbly-color-scheme');
    if(!scheme){
      scheme=document.createElement('meta');
      scheme.id='orbly-color-scheme';
      scheme.name='color-scheme';
      document.head.appendChild(scheme);
    }
    scheme.setAttribute('content',mode==='dark'?'dark light':'light dark');

    document.documentElement.style.colorScheme=mode;
    if(document.body)document.body.style.colorScheme=mode;

    /* iOS 17 fallback, intentionally inactive unless preview device testing proves
       it necessary: remove and append this same single meta once, then restore
       content. Do not reintroduce runtime metas, samplers or scroll/title/lang nudges. */
    // meta.remove(); document.head.appendChild(meta); meta.setAttribute('content',color);
  }

  function apply(mode,anim){
    var h=document.documentElement;
    if(anim){
      h.classList.add('theme-transitioning');
      setTimeout(function(){h.classList.remove('theme-transitioning')},500);
    }

    h.setAttribute('data-theme',mode);

    if(mode===sys()){
      try{localStorage.removeItem(KEY)}catch(e){}
    }else{
      try{localStorage.setItem(KEY,mode)}catch(e){}
    }

    syncThemeMetadata(mode);

    var toggles=document.querySelectorAll('.dark-toggle');
    for(var i=0;i<toggles.length;i++){
      toggles[i].setAttribute('aria-label',mode==='dark'?'Switch to light mode':'Switch to dark mode');
    }
  }

  function init(){
    var saved=stored();
    if(saved&&saved===sys()){
      try{localStorage.removeItem(KEY)}catch(e){}
      saved=null;
    }
    apply(saved&&saved!==sys()?saved:sys(),false);

    document.addEventListener('click',function(e){
      var button=e.target.closest('.dark-toggle');
      if(!button)return;
      apply(cur()==='dark'?'light':'dark',true);
    });

    var mq=window.matchMedia&&window.matchMedia('(prefers-color-scheme:dark)');
    if(mq){
      var handler=function(e){
        if(!stored())apply(e.matches?'dark':'light',false);
      };
      if(mq.addEventListener)mq.addEventListener('change',handler);
      else if(mq.addListener)mq.addListener(handler);
    }
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
